import React from 'react';
import StemContainer from '../../../Containers/AdminContainer/Stem';
const StemScreen = () => {
  return <StemContainer />;
};

export default StemScreen;
